import Button, { ButtonProps } from '@pelckmans/elementis/components/button';
import ButtonDropdown from '@pelckmans/elementis/components/button-dropdown';
import MaterialWordListIcon from '@pelckmans/elementis/icons/material-wordlist';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../../../../contexts/ModalContext';
import useModuleLicenseCheck from '../../../../../hooks/useModuleLicenseCheck';
// eslint-disable-next-line import/no-restricted-paths
import WordlistModal from '../../../../../modules/material/_wordlist/WordlistModal';
import AppsContext from '../../../_contexts/AppsContext';
import ModuleContext from '../../../_contexts/ModuleContext';
import { App } from '../../../api/appsApi';

export default function WordListAppButton({ size = 'md' }: { size?: ButtonProps['size'] }) {
  const { t } = useTranslation();
  const { apps } = useContext(AppsContext);
  const { module } = useContext(ModuleContext);
  const { showModal } = useContext(ModalContext);

  const handleOpenWordlist = (app: App) => {
    return showModal(
      <WordlistModal id="wordlist-modal" wordlistId={app?.linkedApp?.id!} name={app.name} module={module!} />,
    );
  };
  const { isUserLicensed } = useModuleLicenseCheck();

  if (!module) return null;

  const wordLists = apps.filter(
    app => app.platformType === 'P intern' && app.platformLinkType === 'WordList' && app.moduleId === module?.id,
  );

  if (wordLists.length === 0) return null;
  if (wordLists.length === 1) {
    return (
      <Button
        key="word-list-button"
        startIcon={<MaterialWordListIcon data-testid="word-list-icon" />}
        prominence="secondary"
        size={size}
        onClick={() => handleOpenWordlist(wordLists[0])}
        disabled={!isUserLicensed}
        tooltip={!isUserLicensed && t('PAGES.TOC_LEVEL.APPS.WORD_LIST.NO_LICENSE_TOOLTIP')}
      >
        {t('PAGES.TOC_LEVEL.APPS.WORD_LIST.OPEN_WORD_LIST')}
      </Button>
    );
  }

  return (
    <ButtonDropdown
      title={t('PAGES.TOC_LEVEL.APPS.WORD_LIST.OPEN_WORD_LIST')}
      key="word-list-button"
      buttonProps={{
        prominence: 'secondary',
        startIcon: <MaterialWordListIcon data-testid="word-list-icon" />,
        disabled: !isUserLicensed,
      }}
      size={size}
      zIndex={4}
      tooltip={!isUserLicensed && t('PAGES.TOC_LEVEL.APPS.WORD_LIST.NO_LICENSE_TOOLTIP')}
    >
      {wordLists.map(wordList => {
        const isPreview = wordList.state === 'preview';
        const disabledProps = isPreview
          ? ({ disabled: true, tooltip: t('PAGES.TOC_LEVEL.APPS.WORD_LIST.PREVIEW_TOOLTIP') } as const)
          : {};

        return (
          <ButtonDropdown.Item
            as="button"
            key={wordList.id}
            value={wordList.id}
            text={wordList.name}
            textIcon={<MaterialWordListIcon data-testid={`word-list-icon-${wordList.id}`} />}
            onClick={() => handleOpenWordlist(wordList)}
            {...disabledProps}
          />
        );
      })}
    </ButtonDropdown>
  );
}
